import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button } from "reactstrap";

export default function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <Button
      className="btn-icon w-30px h-30px ms-auto ms-3"
      size="sm"
      color="active-light-primary"
      onClick={copy}
    >
      <FontAwesomeIcon icon={copied ? "check" : "copy"}></FontAwesomeIcon>
    </Button>
  );
}
